import type { CompetitorFunnelRow, PerModelBrandValue } from './types';

// ─── Data ────────────────────────────────────────────────────────────────────

export const variableRows = [
  {
    name: 'Broad Approval',
    highlight: true,
    wb: 'W1', wbColor: '#00c9c4', wbBg: '#f0fefe',
    sb: '◆', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.712', bg: '#00c9c4', textColor: '#fff', barFill: 24, delta: '↑1.29', deltaColor: 'rgba(255,255,255,0.75)' },
      { value: '0.828', bg: '#00c9c4', textColor: '#fff', barFill: 28, delta: '↑1.17', deltaColor: 'rgba(255,255,255,0.75)' },
      { value: '0.496', bg: '#3ddad7', textColor: '#004d4a', barFill: 17, delta: '↑1.50', deltaColor: 'rgba(0,77,74,0.7)' },
      { value: '0.448', bg: '#3ddad7', textColor: '#004d4a', barFill: 15, delta: '↑1.55', deltaColor: 'rgba(0,77,74,0.7)' },
    ],
  },
  {
    name: 'Merchant Fee',
    highlight: false,
    wb: 'W1', wbColor: '#00c9c4', wbBg: '#f0fefe',
    sb: '⚡◆', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.464', bg: '#3ddad7', textColor: '#004d4a', barFill: 16, delta: '↑1.54', deltaColor: 'rgba(0,77,74,0.7)' },
      { value: '0.432', bg: '#3ddad7', textColor: '#004d4a', barFill: 14, delta: '↑1.57', deltaColor: 'rgba(0,77,74,0.7)' },
      { value: '0.212', bg: '#80e9e7', textColor: '#005957', barFill: 7, delta: '↑1.79', deltaColor: 'rgba(0,89,87,0.7)' },
      { value: '0.232', bg: '#80e9e7', textColor: '#005957', barFill: 8, delta: '↑1.77', deltaColor: 'rgba(0,89,87,0.7)' },
    ],
  },
  {
    name: 'Zero Patient Fees',
    highlight: false,
    wb: 'W1', wbColor: '#00c9c4', wbBg: '#f0fefe',
    sb: '⚡◆', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.180', bg: '#c0f4f3', textColor: '#006663', barFill: 6, delta: '↑1.82', deltaColor: 'rgba(0,102,99,0.7)' },
      { value: '0.388', bg: '#3ddad7', textColor: '#004d4a', barFill: 13, delta: '↑1.61', deltaColor: 'rgba(0,77,74,0.7)' },
      { value: '0.148', bg: '#c0f4f3', textColor: '#006663', barFill: 5, delta: '↑1.85', deltaColor: 'rgba(0,102,99,0.7)' },
      { value: '0.204', bg: '#80e9e7', textColor: '#005957', barFill: 7, delta: '↑1.80', deltaColor: 'rgba(0,89,87,0.7)' },
    ],
  },
  {
    name: 'Practice Workflow',
    highlight: false,
    wb: 'W2', wbColor: '#28a9d2', wbBg: '#e1f5fb',
    sb: '⚡', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.216', bg: '#80e9e7', textColor: '#005957', barFill: 7, delta: '↑1.78', deltaColor: 'rgba(0,89,87,0.7)' },
      { value: '0.108', bg: '#e8fbfb', textColor: '#338c8a', barFill: 4, delta: '↑1.89', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.048', bg: '#e8fbfb', textColor: '#338c8a', barFill: 2, delta: '↑1.95', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.132', bg: '#c0f4f3', textColor: '#006663', barFill: 4, delta: '↑1.87', deltaColor: 'rgba(0,102,99,0.7)' },
    ],
  },
  {
    name: 'Case Acceptance',
    highlight: false,
    wb: 'W2', wbColor: '#28a9d2', wbBg: '#e1f5fb',
    sb: '⚡◆', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.132', bg: '#c0f4f3', textColor: '#006663', barFill: 4, delta: '↑1.87', deltaColor: 'rgba(0,102,99,0.7)' },
      { value: '0.108', bg: '#e8fbfb', textColor: '#338c8a', barFill: 4, delta: '↑1.89', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.100', bg: '#e8fbfb', textColor: '#338c8a', barFill: 3, delta: '↑1.90', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.132', bg: '#c0f4f3', textColor: '#006663', barFill: 4, delta: '↑1.87', deltaColor: 'rgba(0,102,99,0.7)' },
    ],
  },
  {
    name: 'Staff Training',
    highlight: false,
    wb: 'W2', wbColor: '#28a9d2', wbBg: '#e1f5fb',
    sb: '⚡◆', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.128', bg: '#c0f4f3', textColor: '#006663', barFill: 4, delta: '↑1.87', deltaColor: 'rgba(0,102,99,0.7)' },
      { value: '0.108', bg: '#e8fbfb', textColor: '#338c8a', barFill: 4, delta: '↑1.89', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.084', bg: '#e8fbfb', textColor: '#338c8a', barFill: 3, delta: '↑1.92', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.064', bg: '#e8fbfb', textColor: '#338c8a', barFill: 2, delta: '↑1.94', deltaColor: 'rgba(51,140,138,0.7)' },
    ],
  },
  {
    name: 'Practice Payment',
    highlight: false,
    wb: 'W1', wbColor: '#00c9c4', wbBg: '#f0fefe',
    sb: '⚡', sbColor: '#b2b5b9', sbBg: '#fafafa',
    cells: [
      { value: '0.088', bg: '#e8fbfb', textColor: '#338c8a', barFill: 3, delta: '↑1.91', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.124', bg: '#c0f4f3', textColor: '#006663', barFill: 4, delta: '↑1.88', deltaColor: 'rgba(0,102,99,0.7)' },
      { value: '0.080', bg: '#e8fbfb', textColor: '#338c8a', barFill: 3, delta: '↑1.92', deltaColor: 'rgba(51,140,138,0.7)' },
      { value: '0.068', bg: '#e8fbfb', textColor: '#338c8a', barFill: 2, delta: '↑1.93', deltaColor: 'rgba(51,140,138,0.7)' },
    ],
  },
];

export const modelRows = [
  {
    name: 'ChatGPT',
    dotColor: '#12b76a',
    mention: '68.0%',
    top5: '66.8%',
    primaryRec: '31.2%',
    recColor: '#00c9c4',
    conv: '45.9%',
    convColor: '#00c9c4',
    note: 'Leads primary rec. Highest practice-facing variable encoding — explains the 45.9% conversion rate.',
    inversion: false,
    rowBg: 'transparent',
  },
  {
    name: 'Claude',
    dotColor: '#28a9d2',
    mention: '73.6%',
    top5: '63.2%',
    primaryRec: '19.2%',
    recColor: '#28a9d2',
    conv: '26.1%',
    convColor: '#28a9d2',
    note: 'Highest mention rate but near ceiling on approval encoding. That variable is creating backup positioning.',
    inversion: false,
    rowBg: 'transparent',
  },
  {
    name: 'Gemini',
    dotColor: '#7e5fe0',
    mention: '59.6%',
    top5: '58.0%',
    primaryRec: '11.2%',
    recColor: '#717680',
    conv: '18.8%',
    convColor: '#717680',
    note: '#1 list rate (19.2%) exceeds primary rec (11.2%) — the only model where this inverts.',
    inversion: true,
    rowBg: 'transparent',
  },
  {
    name: 'Perplexity',
    dotColor: '#f93',
    mention: '51.6%',
    top5: '47.2%',
    primaryRec: '10.8%',
    recColor: '#717680',
    conv: '20.9%',
    convColor: '#717680',
    note: 'Lowest scores now, fastest to move. Retrieval-based — the canary for Wave 1 signal.',
    inversion: false,
    rowBg: 'transparent',
  },
];

export const personas = [
  {
    name: 'Practice Owner',
    role: 'Dentist / Owner-operator',
    decisionFrame: 'Strategic: ROI, production growth, patient experience',
    mention: '77%',
    primaryRec: '10%',
    recColor: '#ff6d66',
    accentColor: '#ff6d66',
    isLowest: true,
  },
  {
    name: 'Treatment Coordinator',
    role: 'Chair-side presentation',
    decisionFrame: 'Patient-facing: approval rates, speed, in-chair experience',
    mention: '67%',
    primaryRec: '15%',
    recColor: '#e5991a',
    accentColor: '#ffd600',
    isLowest: false,
  },
  {
    name: 'Office Manager',
    role: 'Vendor evaluation & operations',
    decisionFrame: 'Operational: vendor ease, staff training, reporting visibility',
    mention: '56%',
    primaryRec: '22%',
    recColor: '#28a9d2',
    accentColor: '#28a9d2',
    isLowest: false,
  },
  {
    name: 'DSO Operator',
    role: 'Multi-location group management',
    decisionFrame: 'Scale: standardization, group reporting, consistent rollout',
    mention: '52%',
    primaryRec: '26%',
    recColor: '#00c9c4',
    accentColor: '#00c9c4',
    isLowest: false,
  },
];

export const whatAiSaysPills = ['All Models', 'ChatGPT', 'Claude', 'Gemini', 'Perplexity'];

export const insightCards = [
  {
    id: 1,
    type: 'Contradiction',
    typeColor: '#F97066',
    typeBg: '#FFF4F3',
    accentColor: '#F97066',
    models: ['ChatGPT', 'Claude'],
    headline: "Two models have different information about this. That's a known pattern and it's fixable.",
    snippet: '"No merchant fees for practices in most configurations" — ChatGPT',
    fullQuote: 'ChatGPT: "No merchant fees for practices in most configurations — mentioned explicitly in practice-comparison queries."\n\nClaude: "Sunbit charges a merchant fee, though it varies — imprecise, undercuts the zero-fee claim."\n\nThese two models have indexed opposite facts about the same product attribute. Both are responding to the same category of query. The discrepancy is the kind that surfaces in side-by-side comparisons and undermines purchase confidence.',
    keyPhrase: '"charges a merchant fee" vs. "No merchant fees"',
    source: 'Merchant Fee · Q12: Cost for the practice',
  },
  {
    id: 2,
    type: 'Language mismatch',
    typeColor: '#F97066',
    typeBg: '#FFF4F3',
    accentColor: '#F97066',
    models: ['Perplexity'],
    headline: "One model describes this in a way that doesn't match your voice. Worth looking at.",
    snippet: '"...capture subprime patients."',
    fullQuote: 'Perplexity: "Sunbit — designed to approve up to 80–85% of applicants, including many declined elsewhere. Useful when you want to capture subprime patients."\n\nThis is Perplexity\'s framing in a competitive payment options query. The approval breadth is correct. The language around it is not brand-aligned — "subprime patients" is a lender\'s framing, not Sunbit\'s. Perplexity is retrieval-based, which means this language came from a source it indexed. Finding and correcting that source removes the phrase from the model\'s training pool.',
    keyPhrase: 'capture subprime patients',
    source: 'Perplexity · Payment plan options query',
  },
  {
    id: 3,
    type: 'Convergence',
    typeColor: '#15B79E',
    typeBg: '#F0FDFB',
    accentColor: '#15B79E',
    models: ['ChatGPT', 'Claude', 'Gemini', 'Perplexity'],
    headline: "All four models encode this attribute. It's the one thing that's made it through everywhere.",
    snippet: '"87% approval rate, the broadest across all dental financing options." — ChatGPT',
    fullQuote: 'ChatGPT: "Sunbit markets an 87% approval rate — the broadest across all dental financing options."\n\nClaude: "Excellent for higher approval rates (~85%) — near ceiling encoding across reviewed sources."\n\nGemini: "Sunbit approves a high percentage of patients — mentioned but not quantified in most responses."\n\nPerplexity: "Known for broad approval, though specifics vary by source."\n\nAll four models reach for approval breadth first. This is the brand\'s deepest signal. It also means approval rate is doing the work that six other variables aren\'t doing yet.',
    keyPhrase: 'approval rate',
    source: 'Broad Approval · All models',
  },
  {
    id: 4,
    type: 'Specificity erosion',
    typeColor: '#F79009',
    typeBg: '#FFFAEB',
    accentColor: '#F79009',
    models: ['Perplexity'],
    headline: "The claim is getting through. The precision isn't there yet.",
    snippet: '"Known for broad approval, though specifics vary by source."',
    fullQuote: 'Perplexity: "Known for broad approval, though specifics vary by source."\n\nCompare: ChatGPT: "Sunbit markets an 87% approval rate — the broadest across all dental financing options."\n\nPerplexity is retrieval-based. The hedging phrase — "specifics vary by source" — means it found conflicting numbers across the sources it indexed. ChatGPT has the exact figure. The gap between them is a content consistency problem, not a model problem.',
    keyPhrase: 'specifics vary by source',
    source: 'Broad Approval · Perplexity · Q7: Patient approval rates',
  },
  {
    id: 5,
    type: 'Divergence',
    typeColor: '#28a9d2',
    typeBg: '#E1F5FB',
    accentColor: '#28a9d2',
    models: ['Gemini', 'Claude'],
    headline: "Three models are aligned on this. One is telling a different story.",
    snippet: '"...increasingly Sunbit." — Gemini',
    fullQuote: 'Gemini: "The company that best fits helping the most patients get approved without the practice paying too much is increasingly Sunbit."\n\nClaude: "Cherry (or Sunbit) — backup for patients turned down by the first two, and for smaller add-on treatments."\n\nGemini is reaching the target conclusion. Claude is reaching the opposite one — from the same data set. The divergence is not random. Claude\'s Broad Approval score is near ceiling, which means it\'s encoding approval breadth as a fallback attribute rather than a primary one. The fix is encoding the other six variables, not repeating the approval claim.',
    keyPhrase: 'increasingly Sunbit',
    source: 'All-competitor comparison query',
  },
  {
    id: 6,
    type: 'Not indexed',
    typeColor: '#717680',
    typeBg: '#F7F8FA',
    accentColor: '#b2b5b9',
    models: ['Gemini'],
    headline: "AI hasn't picked this up yet. Here's what that looks like.",
    snippet: '"Workflow data not found in indexed content."',
    fullQuote: 'Gemini: "Workflow data not found in indexed content."\n\nThis is what a 0.048 signal score looks like in practice. Gemini is the model with the inversion anomaly — it lists Sunbit first but won\'t endorse it — and Practice Workflow is the reason. The model can\'t recommend a product it can\'t explain operationally. There is no structured content for Gemini to index here. The Wave 1 Blueprint addresses this directly.',
    keyPhrase: 'not found in indexed content',
    source: 'Practice Workflow · Gemini · Q14: Chair-side workflow',
  },
  {
    id: 7,
    type: 'Almost there',
    typeColor: '#0EA5E9',
    typeBg: '#F0F9FF',
    accentColor: '#0EA5E9',
    models: ['ChatGPT'],
    headline: "This is close to breaking through. A small push moves it.",
    snippet: '"Helps improve case acceptance by making financing accessible at point of care."',
    fullQuote: 'ChatGPT: "Helps improve case acceptance by making financing accessible at point of care."\n\nThis is directionally correct but stops short of a claim. There is no lift figure, no conversion metric, no before-and-after. ChatGPT is building toward a recommendation here and running out of evidence to support it. A single piece of structured case acceptance content — a stat, a case study reference, a testimonial format — would give this response somewhere to go.',
    keyPhrase: 'making financing accessible at point of care',
    source: 'Case Acceptance · ChatGPT · Q16: Practice growth metrics',
  },
  {
    id: 8,
    type: 'Wrong information',
    typeColor: '#F97066',
    typeBg: '#FFF4F3',
    accentColor: '#F97066',
    models: ['Claude'],
    headline: "One model has the wrong information about this. Easy to correct.",
    snippet: '"Sunbit charges a merchant fee, though it varies."',
    fullQuote: 'Claude: "Sunbit charges a merchant fee, though it varies — imprecise, undercuts the zero-fee claim."\n\nThis is a factual error in a high-intent query context. Claude is responding to a practice-facing cost question and returning the wrong answer. The zero-fee model is a primary selling point. An FAQ JSON-LD entry with explicit, crawlable language about merchant fees would give Claude a correctable source. This is the highest-confidence fix in the dataset.',
    keyPhrase: 'charges a merchant fee',
    source: 'Merchant Fee · Claude · Q12: Cost for the practice',
  },
  {
    id: 9,
    type: 'Single model strength',
    typeColor: '#0EA5E9',
    typeBg: '#F0F9FF',
    accentColor: '#0EA5E9',
    models: ['Claude', 'Gemini'],
    headline: "One model has this. The path to the others is clear.",
    snippet: '"No hidden fees for patients." — Claude',
    fullQuote: 'Claude: "No hidden fees for patients — confirmed across multiple query types."\n\nGemini: "Patient fee structure unclear without practice context."\n\nClaude has indexed the zero patient fee claim cleanly. Gemini has not. The gap is not a model difference — it is a content availability difference. Claude found it somewhere. Gemini did not. A dedicated, crawlable page on patient-facing costs would close this.',
    keyPhrase: 'Patient fee structure unclear without practice context',
    source: 'Zero Patient Fees · Q9: Patient-facing cost',
  },
  {
    id: 10,
    type: 'Backup positioning',
    typeColor: '#F97066',
    typeBg: '#FFF4F3',
    accentColor: '#F97066',
    models: ['Claude'],
    headline: "One model positions the brand as a backup here. That's movable.",
    snippet: '"backup for patients turned down by the first two"',
    fullQuote: 'Claude: "Cherry (or Sunbit) — backup for patients turned down by the first two, and for smaller add-on treatments."\n\nThis is Claude\'s response in a direct competitor comparison query. The brand is in third position, defined by what other lenders didn\'t approve. This framing is a product of encoding imbalance — approval breadth at ceiling, practice workflow and case acceptance near zero. The recommendation logic inverts when the other variables carry weight.',
    keyPhrase: 'backup for patients turned down by the first two',
    source: 'Claude · Competitor comparison query',
  },
  {
    id: 11,
    type: 'Persona gap',
    typeColor: '#7e5fe0',
    typeBg: '#EBE7FC',
    accentColor: '#7e5fe0',
    models: ['ChatGPT', 'Claude', 'Gemini', 'Perplexity'],
    headline: "AI sees you differently depending on who's asking. Here's where the gap is.",
    snippet: 'This finding requires persona-tagged quotes. Flagged for next data pass.',
    fullQuote: 'This insight requires persona-tagged query data. Models encode the brand differently depending on which buyer type is doing the research — practice owner, treatment coordinator, office manager, DSO operator.\n\nThe persona data in this study shows significant spread: 77% mention rate for Practice Owner queries vs. 52% for DSO Operator, with primary recommendation rates ranging from 10% to 26% across buyer types. The model-level quotes that explain this gap will be surfaced in the next data pass.',
    keyPhrase: 'persona-tagged query data',
    source: 'Persona data · Flagged for next data pass',
  },
  {
    id: 12,
    type: 'Encoding gap',
    typeColor: '#7e5fe0',
    typeBg: '#EBE7FC',
    accentColor: '#7e5fe0',
    models: ['Claude'],
    headline: "This model knows the brand well. The recommendation rate will follow.",
    snippet: '"Excellent for higher approval rates (~85%)" — Claude',
    fullQuote: 'Claude: "Excellent for higher approval rates (~85%) — near ceiling encoding. This single variable is why Broad Approval creates backup positioning instead of primary recommendation."\n\nClaude has the highest mention rate in the dataset (73.6%) and the second-lowest primary recommendation rate (19.2%). That inversion has a direct cause: the model encodes one variable deeply and reaches ceiling on it. When it has nothing else to say about the brand, it defaults to fallback framing. Encoding the six underdeveloped variables moves the recommendation rate.',
    keyPhrase: 'Excellent for higher approval rates (~85%)',
    source: 'Broad Approval · Claude · Q1: General financing query',
  },
  {
    id: 13,
    type: 'Variable dominance',
    typeColor: '#F79009',
    typeBg: '#FFFAEB',
    accentColor: '#F79009',
    models: ['ChatGPT', 'Claude', 'Gemini', 'Perplexity'],
    headline: "Every model leads with this attribute. The others have room to grow.",
    snippet: '"87% approval rate, the broadest across all dental financing options." — ChatGPT',
    fullQuote: 'ChatGPT: "Sunbit markets an 87% approval rate — the broadest across all dental financing options."\n\nClaude: "Excellent for higher approval rates (~85%)"\n\nGemini: "Sunbit approves a high percentage of patients"\n\nPerplexity: "Known for broad approval, though specifics vary by source."\n\nNote: This is the same data as Card 3 (Convergence). The framing is different. Card 3 is a positive signal — the brand made it through. This card is a risk signal — the brand made it through on one attribute while six others remain at near-zero. The coverage is real. The concentration is the problem.',
    keyPhrase: 'approval rate',
    source: 'Broad Approval · All models',
  },
  {
    id: 14,
    type: 'Unexpected depth',
    typeColor: '#15B79E',
    typeBg: '#F0FDFB',
    accentColor: '#15B79E',
    models: ['Perplexity'],
    headline: "One model goes deeper here than expected. That's a foothold.",
    snippet: '"Sunbit handles fees at the practice level — patients see no direct charge."',
    fullQuote: 'Perplexity: "Sunbit handles fees at the practice level — patients see no direct charge."\n\nPerplexity is generally weaker on this brand than ChatGPT or Claude. This response is an exception. The fee structure is stated precisely, in patient-facing language, with a clear claim. Perplexity is retrieval-based. This level of specificity means it indexed a source that had this exact language. That source exists. If it exists for Perplexity, the same approach works for the other models.',
    keyPhrase: 'patients see no direct charge',
    source: 'Zero Patient Fees · Perplexity · Q9: Patient-facing cost',
  },
  {
    id: 15,
    type: 'Category language',
    typeColor: '#F79009',
    typeBg: '#FFFAEB',
    accentColor: '#F79009',
    models: ['Gemini'],
    headline: "Models are using category language here, not yours. That changes with content.",
    snippet: '"Sunbit approves a high percentage of patients."',
    fullQuote: 'Gemini: "Sunbit approves a high percentage of patients — mentioned but not quantified, weaker than ChatGPT or Claude."\n\nThe phrase "high percentage of patients" is generic category language. Any dental financing provider could say this. The brand\'s actual claim is a specific number — 87% — with a direct comparison to industry norms. Gemini hasn\'t indexed a source with that precision. It is filling the gap with the nearest available descriptor. Structured content with the specific claim language replaces the generic framing.',
    keyPhrase: 'high percentage of patients',
    source: 'Broad Approval · Gemini · Q7: Patient approval rates',
  },
  {
    id: 16,
    type: 'Blueprint gap',
    typeColor: '#7e5fe0',
    typeBg: '#EBE7FC',
    accentColor: '#7e5fe0',
    models: ['Gemini'],
    headline: "This gap connects directly to something already in the roadmap.",
    snippet: '"Merchant fee structure not clearly stated in available sources."',
    fullQuote: 'Gemini: "Merchant fee structure not clearly stated in available sources."\n\nThis is a Wave 1 target. The Blueprint intervention — FAQPage JSON-LD on the Dental Merchant Page — directly addresses this. The structured data gives Gemini a crawlable, unambiguous source for the merchant fee claim. The gap is not a content problem. It is a machine-readability problem. The content exists. The markup doesn\'t.',
    keyPhrase: 'not clearly stated in available sources',
    source: 'Merchant Fee · Gemini · Q12: Cost for the practice',
  },
  {
    id: 17,
    type: 'Mixed signals',
    typeColor: '#7e5fe0',
    typeBg: '#EBE7FC',
    accentColor: '#7e5fe0',
    models: ['Claude'],
    headline: "This response captures both ends of the spectrum. Useful signal.",
    snippet: '"Cherry (or Sunbit): backup for patients turned down by the first two..."',
    fullQuote: 'Claude: "Cherry (or Sunbit) — backup for patients turned down by the first two, and for smaller add-on treatments."\n\nThis quote contains a strong signal and a problem in the same sentence. The strong signal: Claude knows exactly where the brand sits in the competitive stack — which means its training data includes direct competitor comparisons. The problem: the position it has assigned is fallback, not primary. The model has the structure of the argument. It has the wrong conclusion. That is a more tractable fix than teaching a model the brand from scratch.',
    keyPhrase: 'backup for patients turned down by the first two',
    source: 'Claude · Competitor comparison query',
  },
  {
    id: 18,
    type: 'Strongest quote',
    typeColor: '#15B79E',
    typeBg: '#F0FDFB',
    accentColor: '#15B79E',
    models: ['Gemini'],
    headline: "This is the clearest picture of the brand in the full response set.",
    snippet: '"...increasingly Sunbit."',
    fullQuote: 'Gemini: "The company that best fits helping the most patients get approved without the practice paying too much is increasingly Sunbit."\n\nThis is the target state. The language is unprompted, category-definitive, and positions the brand as the answer to the core buyer problem — approval breadth at low practice cost. "Increasingly" signals a trend inference, not just a static fact. Gemini reached this conclusion from its current training data. The goal of the Blueprint is to produce this response from all four models, consistently, across all relevant query types.',
    keyPhrase: 'increasingly Sunbit',
    source: 'Gemini · All-competitor comparison query',
  },
  {
    id: 19,
    type: 'Competitor language',
    typeColor: '#F97066',
    typeBg: '#FFF4F3',
    accentColor: '#F97066',
    models: ['Claude'],
    headline: "Models associate you with language that's closer to a competitor here.",
    snippet: '"turned down by the first two"',
    fullQuote: 'Claude: "Cherry (or Sunbit) — backup for patients turned down by the first two, and for smaller add-on treatments."\n\n"Turned down by the first two" defines the brand\'s approval value relative to Cherry and CareCredit\'s rejection criteria — not relative to Sunbit\'s own claim. The brand\'s positioning is being borrowed from a competitor\'s failure case. This is how category language displaces brand language: the model reaches for the nearest available framing, and that framing belongs to someone else.',
    keyPhrase: 'turned down by the first two',
    source: 'Claude · Competitor comparison query',
  },
  {
    id: 20,
    type: 'Mention gap',
    typeColor: '#F79009',
    typeBg: '#FFFAEB',
    accentColor: '#F79009',
    models: ['Claude'],
    headline: "High mentions, lower recommendations. That gap has a pattern.",
    snippet: '"Excellent for higher approval rates (~85%)" — Claude',
    fullQuote: 'Claude: "Excellent for higher approval rates (~85%) — near ceiling encoding. This single variable is why Broad Approval creates backup positioning instead of primary recommendation."\n\nClaude has the highest mention rate in the dataset: 73.6%. Its primary recommendation rate is 19.2% — second lowest. The gap between mention and recommendation is 54.4 percentage points. One variable at ceiling, six variables near zero. When a model can say one true thing about a brand and nothing else, it mentions the brand but routes the recommendation elsewhere. The fix is not more approval content. It is content on the six attributes Claude cannot currently find.',
    keyPhrase: 'Excellent for higher approval rates (~85%)',
    source: 'Broad Approval · Claude · Q1: General financing query',
  },
];

export const cellQuotes: Record<string, Record<string, { quote: string; framing: string; framingColor: string; framingBg: string; source: string; watch?: string; noEvidence?: boolean }>> = {
  'Broad Approval': {
    ChatGPT: { quote: '"Sunbit markets an 87% approval rate — the broadest across all dental financing options."', framing: 'Strong encoding', framingColor: '#00c9c4', framingBg: '#e1fdfd', source: 'Q4 · Best financing for implants', watch: undefined },
    Claude: { quote: '"Excellent for higher approval rates (~85%)" — near ceiling encoding. This single variable is why Broad Approval creates backup positioning instead of primary rec.', framing: 'Ceiling risk', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q1 · General financing query', watch: 'More encoding here won\'t move the needle — six other variables are the target.' },
    Gemini: { quote: '"Sunbit approves a high percentage of patients" — mentioned but not quantified, weaker than ChatGPT or Claude.', framing: 'Clear encoding', framingColor: '#28a9d2', framingBg: '#e1f5fb', source: 'Q7 · Patient approval rates', watch: undefined },
    Perplexity: { quote: '"Known for broad approval, though specifics vary by source."', framing: 'Clear encoding', framingColor: '#28a9d2', framingBg: '#e1f5fb', source: 'Q7 · Patient approval rates', watch: undefined },
  },
  'Merchant Fee': {
    ChatGPT: { quote: '"No merchant fees for practices in most configurations" — mentioned explicitly in practice-comparison queries.', framing: 'Clear encoding', framingColor: '#28a9d2', framingBg: '#e1f5fb', source: 'Q12 · Cost for the practice', watch: undefined },
    Claude: { quote: '"Sunbit charges a merchant fee, though it varies" — imprecise, undercuts the zero-fee claim.', framing: 'Unclear framing', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q12 · Cost for the practice', watch: 'Claude encodes merchant fee ambiguously — exact language matters here.' },
    Gemini: { quote: '"Merchant fee structure not clearly stated in available sources."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q12 · Cost for the practice', watch: 'Gemini has almost no encoding here — Wave 1 FAQ JSON-LD targets this.' },
    Perplexity: { quote: '"Fee terms depend on the practice agreement."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q12 · Cost for the practice', watch: undefined },
  },
  'Zero Patient Fees': {
    ChatGPT: { quote: '"Patients pay nothing out-of-pocket beyond their plan" — clean, verifiable claim.', framing: 'Faint encoding', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q9 · Patient-facing cost', watch: undefined },
    Claude: { quote: '"No hidden fees for patients" — confirmed across multiple query types.', framing: 'Clear encoding', framingColor: '#28a9d2', framingBg: '#e1f5fb', source: 'Q9 · Patient-facing cost', watch: undefined },
    Gemini: { quote: '"Patient fee structure unclear without practice context."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q9 · Patient-facing cost', watch: 'Gemini needs explicit zero-fee language on the merchant page.' },
    Perplexity: { quote: '"Sunbit handles fees at the practice level — patients see no direct charge."', framing: 'Present', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q9 · Patient-facing cost', watch: undefined },
  },
  'Practice Workflow': {
    ChatGPT: { quote: '"Quick in-chair application, results in seconds" — workflow mentioned in passing but not as a primary feature.', framing: 'Present', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q14 · Chair-side workflow', watch: undefined },
    Claude: { quote: '"Integration details vary by practice management system."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q14 · Chair-side workflow', watch: 'Claude barely encodes workflow — this is a primary blueprint target.' },
    Gemini: { quote: '"Workflow data not found in indexed content."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q14 · Chair-side workflow', watch: 'Gemini Practice Workflow at 0.048 — nearly invisible. Explains the Gemini inversion anomaly.' },
    Perplexity: { quote: '"Sunbit offers a streamlined application process for practices."', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q14 · Chair-side workflow', watch: undefined },
  },
  'Case Acceptance': {
    ChatGPT: { quote: '"Helps improve case acceptance by making financing accessible at point of care."', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q16 · Practice growth metrics', watch: undefined },
    Claude: { quote: '"Case acceptance impact not quantified in current training data."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q16 · Practice growth metrics', watch: 'No model encodes case acceptance strongly — high-value gap for structured content.' },
    Gemini: { quote: '"No specific data on case acceptance lift found."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q16 · Practice growth metrics', watch: undefined },
    Perplexity: { quote: '"Sunbit may improve acceptance rates for larger treatment plans."', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q16 · Practice growth metrics', watch: undefined },
  },
  'Staff Training': {
    ChatGPT: { quote: '"Training resources available through partner portal."', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q21 · Staff onboarding', watch: undefined },
    Claude: { quote: '"Training support mentioned but specifics not indexed."', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q21 · Staff onboarding', watch: undefined },
    Gemini: { quote: '"Staff training details not available in current sources."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q21 · Staff onboarding', watch: undefined },
    Perplexity: { quote: '"Onboarding support is mentioned but not detailed in indexed content."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q21 · Staff onboarding', watch: undefined },
  },
  'Practice Payment': {
    ChatGPT: { quote: '"Practices receive payment within 24–48 hours" — cited in one response, not consistent.', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q18 · Practice cash flow', watch: undefined },
    Claude: { quote: '"Quick practice settlement" — mentioned without specifics in Claude\'s encoding.', framing: 'Faint', framingColor: '#717680', framingBg: '#f7f8fa', source: 'Q18 · Practice cash flow', watch: undefined },
    Gemini: { quote: '"Payment terms to practice not clearly indexed."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q18 · Practice cash flow', watch: 'Immediate payment is a key differentiator — needs explicit structured data.' },
    Perplexity: { quote: '"Payment speed to practice varies by agreement."', framing: 'Absent', framingColor: '#ff6d66', framingBg: '#ffeaea', source: 'Q18 · Practice cash flow', watch: undefined },
  },
};

export const variableScores = [
  { name: 'Broad Patient Approval', score: 0.621, encoded: true,  group: 'encoded' },
  { name: 'Merchant Fee Simplicity',      score: 0.335, encoded: false, group: 'gap' },
  { name: 'Zero Patient Fees',            score: 0.230, encoded: false, group: 'gap' },
  { name: 'Practice-Led Workflow',        score: 0.126, encoded: false, group: 'gap' },
  { name: 'Case Acceptance Lift',         score: 0.118, encoded: false, group: 'gap' },
  { name: 'Staff Training & Support',     score: 0.096, encoded: false, group: 'gap' },
  { name: 'Immediate Practice Payment',   score: 0.090, encoded: false, group: 'gap' },
];

export const personaRows = [
  {
    name: 'Practice Owner',
    role: 'Dentist / Owner-operator',
    decisionFrame: 'Strategic: ROI, production growth, patient experience',
    accentColor: '#ff6d66',
    mention: '77%',
    top5: '72%',
    primaryRec: '10%',
    primaryRecColor: '#ff6d66',
    bestModel: 'ChatGPT',
    bestModelRate: '38%',
    bestModelColor: '#12b76a',
  },
  {
    name: 'Treatment Coordinator',
    role: 'Chair-side presentation',
    decisionFrame: 'Patient-facing: approval rates, speed, in-chair experience',
    accentColor: '#f0a500',
    mention: '67%',
    top5: '63%',
    primaryRec: '15%',
    primaryRecColor: '#ff6d66',
    bestModel: 'ChatGPT',
    bestModelRate: '29%',
    bestModelColor: '#12b76a',
  },
  {
    name: 'Office Manager',
    role: 'Vendor evaluation & operations',
    decisionFrame: 'Operational: vendor ease, staff training, reporting visibility',
    accentColor: '#28a9d2',
    mention: '56%',
    top5: '51%',
    primaryRec: '22%',
    primaryRecColor: '#00c9c4',
    bestModel: 'Claude',
    bestModelRate: '34%',
    bestModelColor: '#28a9d2',
  },
  {
    name: 'DSO Operator',
    role: 'Multi-location group management',
    decisionFrame: 'Scale: standardization, group reporting, consistent rollout',
    accentColor: '#00c9c4',
    mention: '52%',
    top5: '48%',
    primaryRec: '26%',
    primaryRecColor: '#00c9c4',
    bestModel: 'ChatGPT',
    bestModelRate: '41%',
    bestModelColor: '#12b76a',
  },
];

export const personaVariableData: Record<string, { name: string; score: number }[]> = {
  'Practice Owner': [
    { name: 'Broad Patient Approval',   score: 0.68 },
    { name: 'Merchant Fee Simplicity',  score: 0.31 },
    { name: 'Zero Patient Fees',        score: 0.19 },
    { name: 'Case Acceptance Lift',     score: 0.15 },
    { name: 'Practice-Led Workflow',    score: 0.14 },
    { name: 'Staff Training & Support', score: 0.10 },
    { name: 'Immediate Practice Payment', score: 0.08 },
  ],
  'Treatment Coordinator': [
    { name: 'Broad Patient Approval',   score: 0.71 },
    { name: 'Merchant Fee Simplicity',  score: 0.28 },
    { name: 'Zero Patient Fees',        score: 0.26 },
    { name: 'Practice-Led Workflow',    score: 0.18 },
    { name: 'Case Acceptance Lift',     score: 0.11 },
    { name: 'Immediate Practice Payment', score: 0.10 },
    { name: 'Staff Training & Support', score: 0.09 },
  ],
  'Office Manager': [
    { name: 'Broad Patient Approval',   score: 0.58 },
    { name: 'Merchant Fee Simplicity',  score: 0.42 },
    { name: 'Zero Patient Fees',        score: 0.24 },
    { name: 'Practice-Led Workflow',    score: 0.13 },
    { name: 'Case Acceptance Lift',     score: 0.12 },
    { name: 'Staff Training & Support', score: 0.11 },
    { name: 'Immediate Practice Payment', score: 0.09 },
  ],
  'DSO Operator': [
    { name: 'Broad Patient Approval',   score: 0.55 },
    { name: 'Merchant Fee Simplicity',  score: 0.36 },
    { name: 'Zero Patient Fees',        score: 0.21 },
    { name: 'Case Acceptance Lift',     score: 0.13 },
    { name: 'Practice-Led Workflow',    score: 0.12 },
    { name: 'Staff Training & Support', score: 0.10 },
    { name: 'Immediate Practice Payment', score: 0.08 },
  ],
};

export const competitorFunnelData: CompetitorFunnelRow[] = [
  { brand: 'CareCredit', mentionRate: 72.8, top5Rate: 69.4, primaryRecRate: 38.2 },
  { brand: 'Cherry', mentionRate: 66.9, top5Rate: 62.1, primaryRecRate: 28.6 },
  { brand: 'Sunbit', mentionRate: 63.2, top5Rate: 58.8, primaryRecRate: 18.1, focal: true },
  { brand: 'HFD', mentionRate: 12.4, top5Rate: 9.8, primaryRecRate: 4.2 },
];

export const perModelCompetitiveData: { model: string; dotColor: string; brands: PerModelBrandValue[] }[] = [
  {
    model: 'ChatGPT',
    dotColor: '#12b76a',
    brands: [
      { brand: 'CareCredit', value: 71.6 },
      { brand: 'Sunbit', value: 68.0, focal: true },
      { brand: 'Cherry', value: 64.0 },
      { brand: 'HFD', value: 8.8 },
    ],
  },
  {
    model: 'Claude',
    dotColor: '#28a9d2',
    brands: [
      { brand: 'CareCredit', value: 83.2 },
      { brand: 'Cherry', value: 78.4 },
      { brand: 'Sunbit', value: 73.6, focal: true },
      { brand: 'HFD', value: 16.4 },
    ],
  },
  {
    model: 'Gemini',
    dotColor: '#7e5fe0',
    brands: [
      { brand: 'CareCredit', value: 68.4 },
      { brand: 'Cherry', value: 67.6 },
      { brand: 'Sunbit', value: 59.6, focal: true },
      { brand: 'HFD', value: 10.4 },
    ],
  },
  {
    model: 'Perplexity',
    dotColor: '#f93',
    brands: [
      { brand: 'CareCredit', value: 68.0 },
      { brand: 'Cherry', value: 57.6 },
      { brand: 'Sunbit', value: 51.6, focal: true },
      { brand: 'HFD', value: 14.0 },
    ],
  },
];

// ─── Hardcoded blueprint content (Sunbit · May 2026) ─────────────────────────

export const HARDCODED_BLUEPRINT = {
  produced_at: 'May 2026',
  waves: [
    {
      number: 1,
      title: 'Make existing evidence machine-readable',
      subtitle: '4 interventions',
      velocity_label: 'Days to weeks',
      interventions: [
        { id: 'W1-01', title: 'FAQPage JSON-LD on Dental Merchant Page', description: `The 12-question FAQ at /merchant-benefits/dental/ has substantive answers but no structured-data markup. Add FAQPage JSON-LD to the existing FAQ. Tighten three answers to use explicit claim language, for example full payment to the practice after each transaction closes, not contingent on patient repayment, in place of softer phrasing. High confidence intervention.`, effort: 'LOW' as const, signal: 'Velocity · Days' },
        { id: 'W1-02', title: 'Product JSON-LD on Dental Merchant Page', description: `The comparison table containing all six differentiator claims exists as a visual HTML table but may not be easily read by AI. Add Product or Service JSON-LD encoding the table's claims as structured properties. No new content; mirrors what already exists into a parseable format.`, effort: 'LOW' as const, signal: 'Velocity · Days' },
        { id: 'W1-03', title: 'Crawl Access Audit', description: `Schema and language rewrites do nothing if AI crawlers cannot reach the page. GPTBot, ClaudeBot, PerplexityBot, and Googlebot must all be permitted at /merchant-benefits/dental/. Confirm access for each AI crawler.`, effort: 'LOW' as const, signal: 'Velocity · Days' },
        { id: 'W1-04', title: 'Claim Language Tightening', description: `Rework FAQ answers and opening paragraphs to lead with explicit, verifiable claim language. For example: Sunbit charges patients no late fees, no deferred interest, no NSF fees, and no penalty APRs, in place of patients enjoy flexible, transparent financing. No new claims: existing facts, stated precisely.`, effort: 'LOW' as const, signal: 'Velocity · Days' },
      ],
    },
    {
      number: 2,
      title: 'Build the pages models need to explain why Sunbit wins',
      subtitle: '5 interventions',
      velocity_label: 'Weeks to months',
      interventions: [
        { id: 'W2-01', title: 'Standalone Comparison Pages', description: `No dedicated Sunbit page lands "Sunbit vs CareCredit" or "best dental patient financing." Comparison tables are disproportionately extracted by models answering X-vs-Y queries. Build /dental/sunbit-vs-carecredit-vs-cherry-vs-hfd/. Existing comparison table reformatted for extraction. One paragraph per competitor naming the fees Sunbit does not charge. FAQPage schema on the five most common comparison questions.`, effort: 'MEDIUM' as const, signal: 'Velocity into Weight · Weeks to months' },
        { id: 'W2-02', title: 'Three-Post Blog Series', description: `Case-acceptance lift and merchant-fee simplicity focus. Three net-new posts. Numeric claim in the first paragraph and an H2 for snippet extraction. Post 1: Case acceptance. Post 2: Same-day practice payment, every transaction. Post 3: Merchant fees versus industry standards.`, effort: 'MEDIUM' as const, signal: 'Velocity into Weight · Weeks to months' },
        { id: 'W2-03', title: 'Dental Merchant Docs Hub', description: `Create a /docs/dental. Docs sites are high-trust sources for LLM retrieval. Potential topic structures for /docs/dental: onboarding, application workflow with explicit "staff initiates on behalf of patient" language, funding and settlement timing, support escalation, pricing tiers.`, effort: 'MEDIUM' as const, signal: 'Velocity into Weight · Weeks to months' },
        { id: 'W2-04', title: 'DSO-Specific Page', description: `No dedicated DSO page exists. The 200,000+ certified staff figure is on the site but lives in consumer-facing and case-acceptance content. A model reasoning about group-level dental financing partners has no Sunbit surface to land on. Build /dental/dso/. Group-level capability claims: 200,000+ certified staff, group-level reporting dashboard, dedicated rep model, onboarding at scale.`, effort: 'MEDIUM' as const, signal: 'Velocity into Weight · Weeks to months' },
        { id: 'W2-05', title: 'Procedure-Specific Financing Pages', description: `No dedicated Sunbit page exists for procedure-specific financing queries. Three pages: /dental/implant-financing/, /dental/orthodontics-financing/, /dental/cosmetic-dentistry-financing/. Each anchored by a procedure-relevant case study, for example PHD Dental ortho.`, effort: 'MEDIUM' as const, signal: 'Velocity into Weight · Weeks to months' },
      ],
    },
    {
      number: 3,
      title: 'Turn claims into corroborated category evidence',
      subtitle: '6 interventions',
      velocity_label: 'Months to quarters',
      interventions: [
        { id: 'W3-01', title: 'Dental Case Study Rewrites', description: `Five strong case studies name outcomes but never name the Sunbit mechanism that produced them. Add one "Why Sunbit" paragraph per case study naming the 3 to 4 mechanism claims most relevant: fee comparisons, immediate payment, no late fees, workflow.`, effort: 'LOW' as const, signal: 'Weight · Months' },
        { id: 'W3-02', title: 'Knowledge Center Article Rewrites', description: `The only change needed is adding precise claim language at the top of each article and at each relevant section. Small rewrites, high leverage. Specific claim language in the first 200 words and at each relevant H2.`, effort: 'LOW' as const, signal: 'Weight · Months' },
        { id: 'W3-03', title: 'Third-Party Dental Publications', description: `Models already pull from Dental Economics, The Molar Report, DrBicuspid, Group Dentistry Now, and DentistryIQ. Sunbit's specific claims need to appear in those publications. Pitch and place bylined or sponsored pieces that include the differentiator claims. Update Trustpilot and BBB dental-merchant listings with the same language.`, effort: 'HIGH' as const, signal: 'Weight · Months' },
        { id: 'W3-04', title: 'Dental Software Integration Pages', description: `Zuub and Weave are listed as integration partners with one testimonial each. No dedicated pages. Build dedicated sub-pages for each integration covering workflow, staff-initiated application language, and immediate practice payment in integration context.`, effort: 'MEDIUM' as const, signal: 'Weight · Months' },
        { id: 'W3-05', title: 'Open-Source Dental Financing Calculator (Experimental)', description: `GitHub READMEs carry technical credibility that brand-owned content cannot, and they are weighted in some training corpora. Publish a repo with a README benchmarking effective merchant fees across providers (Sunbit ~5 to 6%) and modeling case-acceptance lift.`, effort: 'MEDIUM' as const, signal: 'Weight · Months' },
        { id: 'W3-06', title: 'Quarterly Sunbit Dental Index', description: `Recurring reports can become sources models cite when asked for benchmark figures. Sunbit has the data: case acceptance lift, merchant effective rate, certified staff, funding time. Publish a recurring quarterly report establishing Sunbit as the authoritative numeric source for dental BNPL benchmarks.`, effort: 'HIGH' as const, signal: 'Weight · Months' },
      ],
    },
  ],
};
